/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Giorni consecutivi a partire da oggi (mezzanotte locale). */
export const daysAhead = (n) => {
  const arr = [];
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  for (let i = 0; i < n; i++) {
    const d = new Date(now);
    d.setDate(now.getDate() + i);
    arr.push(d);
  }
  return arr;
};

const dotClass = (active, done) => {
  if (done) return 'bg-accent text-accent-foreground';
  if (active) return 'bg-primary text-primary-foreground';
  return 'bg-muted text-muted-foreground';
};

export const StepDot = ({ active, done, num, label }) => (
  <div className="flex items-center gap-2" data-testid={`booking-step-dot-${num}`}>
    <div className={cn('h-7 w-7 rounded-full flex items-center justify-center text-xs font-bold transition-colors', dotClass(active, done))}>
      {done ? <CheckCircle2 className="h-4 w-4" /> : num}
    </div>
    <span className={cn('text-xs font-medium hidden sm:inline', active || done ? 'text-foreground' : 'text-muted-foreground')}>
      {label}
    </span>
  </div>
);

/** Stepper a 3 passi: Slot → Triage → Riepilogo. */
export const WizardStepper = ({ step }) => {
  const { t } = useTranslation();
  return (
    <div className="px-5 py-3 border-b border-border flex items-center gap-4 justify-center" data-testid="booking-stepper">
      <StepDot num={1} active={step === 0} done={step > 0} label={t('bookStep1')} />
      <div className="h-px w-8 bg-border" />
      <StepDot num={2} active={step === 1} done={step > 1} label={t('bookStep2')} />
      <div className="h-px w-8 bg-border" />
      <StepDot num={3} active={step === 2} done={false} label={t('bookStep3')} />
    </div>
  );
};
